import { render, staticRenderFns } from "./DependencyGrid.vue?vue&type=template&id=27b146f2&scoped=true"
import script from "./DependencyGrid.vue?vue&type=script&lang=js"
export * from "./DependencyGrid.vue?vue&type=script&lang=js"
import style0 from "./DependencyGrid.vue?vue&type=style&index=0&id=27b146f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b146f2",
  null
  
)

export default component.exports